/**
 * @file Contains classes for different types of filters
 * @author Jimmy Messmer
 */

import React from 'react'
import FilterItem from './FilterItem'

import {
  Row,
  Col,
  Input,
  Form,
  FormGroup
} from 'reactstrap'

// import { Range } from 'rc-slider'
import InputRange from 'react-input-range'

import 'react-input-range/lib/css/index.css'

/**
 * React component for a checkbox. This one is pretty simple--just returns a checkbox for each tag prop
 * @class CheckboxFilterList
 */
class CheckboxFilterList extends React.Component {
  constructor(props) {
    super(props)
    this.addFilter = this.addFilter.bind(this)
    this.state = {
      activeFilters: this.props.tags.filter(tag => tag.active).map(tag => tag.name)
    }
  }

  addFilter(newFilter) {
    let oldFilters = JSON.parse(JSON.stringify(this.state.activeFilters))
    let newFilters = []
    if (oldFilters.indexOf(newFilter) < 0) {
      oldFilters.push(newFilter)
      newFilters = oldFilters
    } else {
      newFilters = oldFilters.filter(val => val !== newFilter)
    }

    this.setState({
      activeFilters: newFilters
    })

    this.props.callback(newFilters, [newFilter])
  }

  render() {
    return (
      this.props.tags.map(tag => (
        <FilterItem defaultChecked={tag.active} clear={this.props.clear} key={tag.name} filterName={tag.name} disabled={tag.disabled} filterQty={this.props.tags[tag]} callback={() => this.addFilter(tag.name)} />
      ))
    )
  }
}

/**
 * React component for a slider.
 * @class SliderFilterList
 */
class SliderFilterList extends React.Component {
  constructor(props) {
    super(props)
    this.onSliderChange = this.onSliderChange.bind(this)
    this.onToggleChange = this.onToggleChange.bind(this)
    this.updateMarks = this.updateMarks.bind(this)
    let leftMark = 0
    let rightMark = this.props.tags.length - 1
    for (let i = 0; i < this.props.tags.length; i++) {
      if (this.props.tags[i].active) {
        leftMark = i
        break
      }
    }
    for (let i = this.props.tags.length - 1; i >= 0; i--) {
      if (this.props.tags[i].active) {
        rightMark = i
        break
      }
    }
    this.state = {
      value: {
        min: leftMark,
        max: rightMark
      },
      tempValue:{
        min: leftMark,
        max: rightMark
      },
      active: this.props.tags.filter(tag => tag.active).length > 0,
      cleared: false
    }
  }

  componentDidMount(){
    const urlParams = new URLSearchParams(window.location.search)

    const allParamKeys = urlParams.getAll(this.props.setName)
    // eslint-disable-next-line
    if(allParamKeys.length > 0){
      let entries = allParamKeys[0].split(",")
      let vals = []
      for (let i = 0; i < entries.length; i++) {
        vals.push(atob(entries[i]))
      }
        
      let setMin = this.props.tags.findIndex(tag => vals[0] === tag.name)
      let setMax = this.props.tags.findIndex(tag => vals[vals.length -1] === tag.name)
      
        this.setState({
          active: true,
          value: {
            min: setMin,
            max: setMax
          },
          tempValue:{
            min:setMin,
            max:setMax
          }
          
        })

      }
    }
  
  /**
   * Reset the filter if the entire set is toggled off
   * @param {*} prevProps Old props for component
   */
  componentDidUpdate(prevProps) {
    if (prevProps.hidden === false && this.props.hidden === true) {
      this.setState({
        value: {
          min: 0,
          max: this.props.tags.length - 1
        },
        active: false
      })
    }
    else if (this.props.onClear===false && this.state.active===true) {
      this.setState({
        value: {
          min: 0,
          max: this.props.tags.length - 1
        },
            tempValue:{
              min:0,
              max:this.props.tags.length -1
            },
        active: false
      })
    }
  }

  /**
   * Update the matches from the slider element when it is updated 
   * @param {array} args Array of arguments--first element is the minimum value, second the maximum
   */
  onSliderChange(newValue) {
    if(!this.state.active){
      this.onToggleChange()
    }
    // We should be able to just get all the current filters outside of the current age group + the selected ages
    if (this.state.active) {
      let oldMatches = this.props.tags.slice(this.state.value.min, this.state.value.max + 1).map(match => match.name)
      let matches = this.props.tags.slice(newValue.min, newValue.max + 1).map(match => match.name)
      let diff = []
      if (oldMatches.length > matches.length) {
        diff = oldMatches.filter(val => matches.indexOf(val) < 0)
      } else {
        diff = matches.filter(val => oldMatches.indexOf(val) < 0)
      }
      this.setState({
        value: {
          min: newValue.min,
          max:newValue.max
        }
      })
      this.props.callback(matches, diff)
    }
  }
  

  onToggleChange() {
    if (!this.state.active) {
      let matches = this.props.tags
      this.props.callback(matches.map(match => match.name), matches.map(match => match.name))
    } else {
      this.props.callback([], this.props.tags.slice(this.state.value.min, this.state.value.max + 1).map(tag => tag.name))
      this.setState({
        value: {
          min: 0,
          max: this.props.tags.length - 1
        },
        tempValue:{
          min:0,
          max:this.props.tags.length-1
        }
      })
    }
    this.setState(prevState => ({
      active: !prevState.active
    }))
  }

  /**
   * Update min and max marks on the slider element
   * @param {array} args Array with new minimum and maximum values
   */
  updateMarks(args) {
    this.setState({
      min: args[0],
      max: args[1]
    })
  }

  render() {
    if (this.props.hidden) {
      return null
    } else {
      return (
        <div>
          <Row className='age-slider pancreatlas-row'>
            <Form style={{ minWidth: '14rem' }} inline>
              <FormGroup style={{ width: '100%' }}>
                <Col xs={2}>
                  <Input type='checkbox' checked={this.state.active} onChange={this.onToggleChange} />
                </Col>
                <Col xs={10}>
                <InputRange
                        formatLabel={value => `${this.props.tags[value]['name']}`}
                        maxValue={this.props.tags.length - 1}
                        minValue={0}
                        value={this.state.tempValue}
                        onChange={value => this.setState({tempValue: {min: value.min,max:value.max} })}
                        onChangeComplete={value => this.onSliderChange(value)}
                  />
                </Col>
              </FormGroup>
            </Form>
          </Row>
        </div>
      )
    }
  }

}

export { CheckboxFilterList, SliderFilterList }